import { Stack, useTheme } from "@mui/material"
import { Chip } from "@pharmupp/p3-front-commons"
import { AlertCircle } from "react-feather"
import { type NewsCategory, PostType } from "../../../News/model"
import { EventCancelledChip } from "../../EventCancelledChip"
import type { FormattedNews } from "./News"

export const NewsCategoryChip = ({
  news,
  category,
}: { news: FormattedNews; category?: NewsCategory }) => {
  const theme = useTheme()

  if (news.postType === PostType.EVENT) {
    return news?.cancelled ? (
      <Stack direction="row" spacing={1} color="common.red">
        <AlertCircle />
        <EventCancelledChip />
      </Stack>
    ) : (
      <Chip
        label="ÉVÈNEMENT"
        size="small"
        fontColor={theme.palette.common.white}
        backgroundColor={theme.palette.common.electricBlue}
        sx={{ fontSize: "0.6rem" }}
      />
    )
  }

  if (category) {
    return (
      <Chip
        label={category.label}
        size="small"
        fontColor={category.color?.fontColor}
        backgroundColor={category.color?.bkgColor}
        sx={{ fontSize: "0.6rem" }}
      />
    )
  }

  return null
}
